<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<ng-container [formGroup]="form">
  <well-subscription-type-inputs
    formControlName="subscriptionType"
    [isEditMode] = isEditMode()
    [dirty]="form.dirty"
    [touched]="form.touched" data-testid="subscription-type-input">
  </well-subscription-type-inputs>



  <p-messages [(value)]="msg"></p-messages>

</ng-container>


